// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import styled from 'styled-components';
import LevelCondition from './LevelCondition';

export const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  `,
  Row: styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
  `,
  LevelCondition: styled(LevelCondition)`
    display: flex;
    margin: 33px;
  `
};
